export const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  const normalized = hex.replace("#", "").trim();
  if (normalized.length !== 6) return null;
  const r = Number.parseInt(normalized.slice(0, 2), 16);
  const g = Number.parseInt(normalized.slice(2, 4), 16);
  const b = Number.parseInt(normalized.slice(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return null;
  return { r, g, b };
};

export const withAlpha = (hex: string, alpha: number) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex;
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
};

export const getReadableTextColor = (hex: string) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return "#111827";

  const toLinear = (v: number) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };

  const r = toLinear(rgb.r);
  const g = toLinear(rgb.g);
  const b = toLinear(rgb.b);
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance < 0.5 ? "#ffffff" : "#111827";
};

export const formatWorkingTimeModels = (models?: string[]) => {
  if (!models || models.length === 0) return "";
  const map: Record<string, string> = {
    fullTime: "Vollzeit",
    partTime: "Teilzeit",
    miniJob: "Minijob",
    student: "Werkstudent",
    temporary: "Befristet",
    apprenticeship: "Ausbildung",
    internship: "Praktikum",
  };
  const labels = models.map((m) => map[m] || m);
  return labels.join(", ");
};

/** Hero / list card: hide when API sets `showImage: false`; otherwise show when a non-empty image URL exists. */
export function shouldRenderJobPreviewImage(p: { previewImageUrl?: string; showImage?: boolean }): boolean {
  if (p.showImage === false) return false;
  return Boolean(p.previewImageUrl?.trim());
}

